export const emojiReactions = [
   { id: 1, name: 'like', value: '\u{1F44D}' },
   { id: 2, name: 'funny', value: '\u{1F602}' },
   { id: 3, name: 'wholesome', value: '\u{1F60A}' },
   { id: 4, name: 'fear', value: '\u{1F631}' },
   { id: 5, name: 'astonished', value: '\u{1F632}' },
   { id: 6, name: 'angry', value: '\u{1F621}' },
];
